import { FC } from 'react'
import { AuctionByArtworkQuery, GetEventAuctionByIdQuery } from 'gql'
import getUserBiddingStatusOnArtwork from '../bid-helpers'

import TimeLeftComponent from './component'

interface TimeLeftProps {
  artworkNode: GetEventAuctionByIdQuery['findArtwork']
  auction: AuctionByArtworkQuery['auction']
  loading?: boolean
  prefix?: string
}

const TimeLeft: FC<TimeLeftProps> = ({ prefix, artworkNode, loading, auction }) => {
  const tz = artworkNode.venue.timeZone
  const endDate = auction?.endDate
  const startDate = auction?.startDate

  const { willStart } = getUserBiddingStatusOnArtwork({
    start: startDate,
    end: endDate,
  })

  if (willStart) {
    return null
  }

  return <TimeLeftComponent prefix={prefix} tz={tz} date={endDate} loading={loading} />
}

export default TimeLeft
